import Vue from 'vue';
import { classTracker, trackerEnv } from '@iv/shared/src/tracker';
import videosize from './directive/videosize';
import fseq from './directive/fseq';
import evts from './directive/evts';
import { log } from './utils';
import { CompsBridge } from '../MessageChannel';

@classTracker(false, trackerEnv.child, ['initCompsEnv'])
class InteractComps {
  public constructor() {
    log('组件运行环境开始加载');
    window.iBridge = CompsBridge.init();
    window.vBridge = window.iBridge;
    this.initCompsEnv();
  }

  private async initCompsEnv() {
    const App = await import('./icomps.vue');
    Vue.directive('videosize', videosize);
    Vue.directive('evts', evts);
    Vue.directive('fseq', fseq);
    new Vue({
      render: (h: Function) => h(App.default),
    }).$mount('#iv-app');
  }
}

export default InteractComps;
